import { incYenOf, incOf } from '../lib/pricing';
export const automotiveHero = {
  title: '自動車・モビリティ向け 法人研修',
  titleEn: 'FOR AUTOMOTIVE & MOBILITY',
  lead: 'ブランド体験の質を、執事の所作に基づくビジネスマナー研修で高めるプログラムです。',
};

export const automotiveTrustBadges = [
  {
    icon: 'ri-car-line',
    text: 'ブランド体験・イベント接遇の型を確立',
  },
  {
    icon: 'ri-map-pin-user-line',
    text: '出張型で貴社の現場に合わせた訓練',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const automotivePainPoints = [
  {
    icon: 'ri-store-2-line',
    text: 'ブランド体験施設・ショールームの「もてなし」がブランドの世界観に追いついていない',
  },
  {
    icon: 'ri-calendar-event-line',
    text: 'メーカー主催の試乗会・発表会・オーナーズイベントの接遇を統一したい',
  },
  {
    icon: 'ri-vip-crown-line',
    text: '株主・VIP・メディアの来場対応に自信がない',
  },
  {
    icon: 'ri-share-line',
    text: '販売店スタッフへ展開できる接遇の型がない',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-shield-user-line',
    title: '来賓を迎え、場を整え、満足を設計する技術',
    description:
      '執事は、ひとりの主を迎えるために所作を磨き、場を整え、滞りのない時間を設計する技術を何世代にもわたって体系化してきました。この「もてなしの型」は、ブランド体験施設やイベントで来場者を迎える現場にそのまま応用できます。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'ブランド体験と重なる所作',
    description:
      'お出迎えの第一声、ご案内の動線、車両前での立ち位置と説明の所作——これらはすべて、執事が来賓を迎えるときの所作と重なります。本研修では、ブランドの世界観を「所作」で体現する技術をお伝えします。',
  },
  {
    icon: 'ri-tools-line',
    title: '座学ではなく実技で型を渡す',
    description:
      '座学で概念を学ぶだけでは、現場で再現できません。本研修は実技中心で構成し、受講者の身体に型を覚えさせることで、研修翌日から現場で使える品質を目指します。また、型を言語化してお渡しするため、社内での自主訓練や点検基準としてもご活用いただけます。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M3（おもてなし・ご案内実技）',
    description:
      'ブランド体験施設の現場ですぐ使える立ち居振る舞いとご案内の型に集中する短期プランです。まずは試行的に導入したい場合や、特定の課題に絞ったブラッシュアップに適しています。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2（VIP・来賓対応の原則）＋ M3 ＋ M4（イベント想定ロールプレイング）',
    description:
      '立ち居振る舞いからVIP・来賓対応の原則、イベントを想定したロールプレイングまで、ブランド体験の接遇基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: 'イベント前集中',
    duration: '1〜2日（応相談）',
    price: `${incYenOf('ct-single-fullday')}〜${incYenOf('ct-single-2day')}`,
    modules: '発表会・試乗会の運営に合わせた通し稽古',
    description:
      '発表会や試乗会の日程に合わせ、受付からお見送りまでの全動線を通し稽古する集中プランです。イベントの運営マニュアルを事前にお預かりし、貴社の流れに沿った実技訓練を設計します。',
  },
];

export const automotiveScenarios = [
  {
    number: '01',
    title: 'ブランド体験施設での来場対応',
    description:
      'お出迎えの第一声から、ご案内動線での距離感と歩調、車両前でのご説明時の立ち位置と所作、質疑応答での姿勢と目線の配り方まで、ブランド体験施設での一連の接遇を反復練習します。特に来場者が最初に感じる「迎え入れの質」に重点を置き、施設の世界観を所作で体現する技術を習得します。',
    imageSeq: 'auto-scenario-1',
  },
  {
    number: '02',
    title: '試乗会・オーナーズイベント',
    description:
      '受付での第一印象から、待ち時間の気配り、試乗前のご案内、ご家族・同伴者への配慮、お見送りまで、イベントの全接点を通し稽古します。イベントでは来場者の属性や期待値が多様であるため、状況に応じた対応の引き出しを増やす訓練を行います。',
    imageSeq: 'auto-scenario-2',
  },
  {
    number: '03',
    title: '株主・VIP・メディアの来場対応',
    description:
      '席次の考え方、正しい呼称と紹介の作法、写真撮影時の立ち位置と配慮、オフレコ対応の線引きなど、格式が求められる場での対応をロールプレイングで訓練します。単なるマニュアル対応ではなく、相手の立場に立った「先回りの気配り」を体得します。',
    imageSeq: 'auto-scenario-3',
  },
];

export const automotiveTargetRoles = [
  'ブランド体験施設スタッフ',
  'イベント運営担当',
  '広報・顧客リレーション',
  '受付・ホスピタリティ担当',
  '販売店指導担当',
];

export const automotivePricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '12時間（2日間）',
    price: incYenOf('ct-single-2day'),
    note: '全6モジュール受講可',
  },
];

export const automotivePricingConditions = {
  dispatch: '出張時の交通費・宿泊費は実費別途',
  capacity: '推奨12名まで（超過は2班制等をご提案）',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const automotiveFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '対象人数・課題・希望時期・イベント予定などをオンラインまたはお電話で伺います。',
  },
  {
    step: '03',
    title: '提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴社の施設・イベントに最適な研修プログラムとお見積りをご提案します。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では実際のブランド体験施設や会場で訓練します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const automotiveCategoryOptions = [
  { value: '', label: '選択してください' },
  { value: 'automaker', label: '完成車メーカー' },
  { value: 'importer', label: 'インポーター' },
  { value: 'mobility', label: 'モビリティ' },
  { value: 'dealer', label: '販売店本部' },
  { value: 'other', label: 'その他' },
];

export const automotiveFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const automotiveFaqs = [
  {
    question: '執事の資格が取れますか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修で、資格付与はありません。受講証（参加証明）を発行できます。',
  },
  {
    question: 'イベント直前でも実施できますか？',
    answer:
      'はい。発表会・試乗会の日程に合わせた集中実施と通し稽古が可能です。',
  },
  {
    question: '料金はいくらですか？',
    answer:
      '半日220,000円、1日330,000円（いずれも税込）からです。出張時の交通費・宿泊費は実費を別途申し受けます。',
  },
];

export const automotiveRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: '開業前研修からバトラーサービスの型まで',
    href: '/corporate/hotel',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
  },
];